module.exports = __webpack_public_path__ + "static/OneDotCd-Italic.ae25e6ea.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotCd-Italic.woff2
// module id = 746
// module chunks = 114276838955818